import { ArrowIcon } from "../components/Icons";
import { PageHero } from "../components/PageHero";
import { BOOKING_URL, staff } from "../site";

export function StaffPage() {
  return (
    <>
      <PageHero
        eyebrow="Staff"
        title="Come join the Nadia’s family."
        description="At Nadia’s Family Salon, we want you to look and feel your best. The perfect cut, color, or specialty hair treatment can make a difference in your look."
        image="/images/salon-hero.jpg"
      />
      <section className="section staff-section">
        <div className="container">
          <div className="section-heading section-heading--split section-heading--dark">
            <div><p className="eyebrow">Our staff</p><h2>Professional skill.<br />Personal attention.</h2></div>
            <p>Come let our professionals give you the look of a lifetime. Come in and join the Nadia’s family.</p>
          </div>
          <div className="staff-list">
            {staff.map((member, index) => (
              <article className="staff-profile" key={member.name}>
                <div className="staff-profile__portrait">
                  <img src={member.image} alt={member.alt} loading={index > 1 ? "lazy" : "eager"} decoding="async" />
                  <span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
                </div>
                <div className="staff-profile__content">
                  <h2>{member.name}</h2>
                  <section>
                    <h3>About</h3>
                    <p>{member.about}</p>
                  </section>
                  {"certifications" in member && (
                    <section>
                      <h3>Certifications and continuing education</h3>
                      <p>{member.certifications}</p>
                    </section>
                  )}
                  {"specialties" in member && (
                    <section>
                      <h3>Specialities</h3>
                      <p>{member.specialties}</p>
                    </section>
                  )}
                </div>
              </article>
            ))}
          </div>
          <div className="staff-booking">
            <div><p className="eyebrow">Find your fit</p><h2>Not sure who to book?</h2><p>Call the salon and tell us what you have in mind. We’ll help match your service and timing to the right professional.</p></div>
            <a className="button" href={BOOKING_URL} target="_blank" rel="noreferrer">View online availability <ArrowIcon /></a>
          </div>
        </div>
      </section>
    </>
  );
}
